/* eslint-disable import/prefer-default-export */
import { useQuery } from '@tanstack/react-query';

import dayjs from 'shared/helpers/dayjs';
import { APIKey, apiRoutes } from 'constants/apiKeys';
import baseFetcher from 'shared/helpers/baseFetcher';
import { Event } from 'events/_types';
import { PaginatedResponse } from 'dashboard/types';
import {
  EMPTY_FILTERS,
  FilterValues,
} from 'events/components/FilterGroupingControl/_types';
import buildEventsListQuery from 'events/helpers/eventFilters';
import formatDateParam from 'events/helpers/dateFormat';

const RECENT_EVENT_WINDOW_MS = 2 * 60 * 1000;
const PENDING_POLL_INTERVAL_MS = 3_000;
const IDLE_POLL_INTERVAL_MS = 30_000;

export function useEvents(date: string, filters: FilterValues = EMPTY_FILTERS) {
  const query = buildEventsListQuery(date, filters);
  return useQuery<PaginatedResponse<Event>>({
    queryKey: [APIKey.EVENT, 'list', query],
    queryFn: () => baseFetcher(`${apiRoutes.events()}?${query}`),
    enabled: !!date,
    refetchInterval: (rqQuery) => {
      const events = rqQuery.state.data?.results ?? [];
      const now = Date.now();
      const hasRecentUnpopulated = events.some(
        (event) =>
          !event.summary &&
          now - new Date(event.created).getTime() < RECENT_EVENT_WINDOW_MS
      );
      if (hasRecentUnpopulated) return PENDING_POLL_INTERVAL_MS;
      return date === formatDateParam(dayjs()) ? IDLE_POLL_INTERVAL_MS : false;
    },
    refetchOnWindowFocus: true,
  });
}
